





















































































import { Component, Prop, Vue } from "vue-property-decorator";

import DisplayPassword from "../resources/displayPassword.vue";

@Component({
  components: {
      DisplayPassword
  }
})

export default class changePasswordModal extends Vue {
    @Prop() private isError! : boolean;
    @Prop() private errorMessages! : Array<{index : number, message: string}>;

    title = "パスワード変更";
    isLook  = false;

    oldPassword = "";
    password = "";
    rePassword = "";
    isCanSubmit = false;

    private mounted(){
        (this.$refs.oldPassword as HTMLElement).focus();
    }

    private onDoCommand(command: string, param: any){
        this.$emit("doCommand", command, param);
    }

    private setCanSubmit(){
        this.isCanSubmit = true;
    }

    private keyupEnter(element){
        if(!this.isCanSubmit){ return; }
        this.isCanSubmit = false;
        (this.$refs[element] as HTMLElement).blur();
        if(this.oldPassword == "" || this.password == "" || this.rePassword == ""){ return; }
        this.save();
    }

    private cansel(){
        this.onDoCommand("cansel", null);
    }

    private save(){
        var param = {
            oldPassword: this.oldPassword,
            password: this.password,
            rePassword: this.rePassword
        }
        this.onDoCommand("savePassword", param);
    }

    private forgot(){
        this.onDoCommand("forgot", null);
    }

    private get changeLook(){
        return this.isLook ? "text" : "password";
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
